import {
  ExistsChildElement,
  IsChildElementForJustOne,
  AddClass,
  RemoveClass,
  IsEmptyText,
  UpdateElement,
  UpdateGlobalVariableByChildElement,
  UpdateGlobalVariableByAttr,
  UpdateGlobalVariableBeforeChange,
  UpdateGlobalVariableAfterChange,
  UpdateGlobalVariableForSup,
  UpdateWcContent,
  SetCurrentAttr,
  SetRestAttr,
  SetDiscountedAttr,
  UpdateGlobalVariableForWc,
} from './carriageFee.types';
import $ from 'jquery';

/**
 * 指定した要素の子要素の存在確認を行う
 *
 * @param selector 指定した要素
 * @param childSelector 子要素
 * @returns 指定した要素の子要素が存在するかどうか
 */
export const existsChildElement: ExistsChildElement = (
  selector,
  childSelector
) => $(selector).find(childSelector).length > 0;

/**
 * 指定した要素の子要素が１つだけ存在するかどうかの確認を行う
 *
 * @param selector 指定した要素
 * @param childSelector 子要素
 * @returns 指定した要素の子要素が１つだけ存在するかどうか
 */
export const isChildElementForJustOne: IsChildElementForJustOne = (
  selector,
  childSelector
) => $(selector).find(childSelector).length === 1;

/**
 * 指定した要素にクラスを付与する
 *
 * @param selector 指定した要素
 * @param className 付与するクラス名
 */
export const addClass: AddClass = (selector, className) => {
  $(selector).addClass(className);
};

/**
 * 指定した要素のクラスを削除する
 *
 * @param selector 指定した要素
 * @param className 削除するクラス名
 */
export const removeClass: RemoveClass = (selector, className) => {
  $(selector).removeClass(className);
};

/**
 * 指定した要素の文字が空文字かどうか確認する
 *
 * @param selector 指定した要素
 * @returns 指定した要素の文字が空文字かどうか
 */
export const isEmptyText: IsEmptyText = (selector) =>
  $(selector).text().length === 0;

/**
 * 要素の存在確認をし、存在した場合要素の更新を行う
 *
 * @param existsElement 要素の存在確認を行う関数
 * @param setContentToElement 指定した要素のテキストを書き換える関数
 * @param addClass 指定した要素にクラスを付与する関数
 * @param removeClass 指定した要素のクラスを削除する関数
 * @param existsChildElement 指定した要素の子要素の存在確認を行う関数
 * @param selector 指定した要素
 * @param childSelector 指定した子要素
 * @param className クラスネーム
 * @param setAttr 属性を設定する関数
 * @param setCurrentAttr 現在の手数料の属性値を設定する関数
 * @param setRestAttr 残りの値段の属性値をを設定する関数
 * @param setDiscountedAttr 次の手数料の属性値を設定する関数
 * @param wcSelector wc用のセレクター
 * @param currentAttr 現在の手数料の属性名
 * @param restAttr 残りの値段の属性名
 * @param discountedAttr 次の手数料の属性名
 * @param currentSelector 現在の手数料用のセレクター
 * @param restSelector 残りの値段用のセレクター
 * @param restAttrName 残りの値段用の属性名
 * @param discountedSelector 次の手数料用のセレクター
 * @param subject 手数料名
 * @param removeAttr 属性を削除する関数
 */
export const updateElement: UpdateElement = (
  existsElement,
  setContentToElement,
  addClass,
  removeClass,
  existsChildElement,
  selector,
  childSelector,
  className,
  getElement,
  updateWcContent,
  setAttr,
  setCurrentAttr,
  setRestAttr,
  setDiscountedAttr,
  wcSelector,
  currentAttr,
  restAttr,
  discountedAttr,
  currentSelector,
  restSelector,
  restAttrName,
  subject,
  removeAttr
) => (content) => {
  const element = getElement(wcSelector);
  if (element)
    updateWcContent(
      setAttr,
      setCurrentAttr,
      setRestAttr,
      setDiscountedAttr,
      removeAttr,
      element,
      currentAttr,
      restAttr,
      discountedAttr,
      currentSelector,
      restSelector,
      restAttrName,
      childSelector,
      subject,
      content
    );
  if (existsElement(selector)) {
    setContentToElement(selector, content);
    if (existsChildElement(selector, childSelector)) {
      addClass(selector, className);
    } else {
      removeClass(selector, className);
    }
  }
};

/**
 * 子要素の値の数値部分を抽出してグローバル変数を更新する関数を実行する
 *
 * @param selector 指定した要素
 * @param childSelector 指定した子要素
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param updateGlobalVariable グローバル変数を更新する関数
 */
export const updateGlobalVariableByChildElement: UpdateGlobalVariableByChildElement = (
  selector,
  childSelector,
  globalObj,
  propertyName,
  updateGlobalVariable
) => {
  updateGlobalVariable(
    globalObj,
    propertyName,
    parseInt(
      $(selector)
        .find(childSelector)
        .text()
        .replace(/[^0-9]/g, '')
    )
  );
};

/**
 * 指定した要素の属性の値の数値部分を抽出してグローバル変数を更新する関数を実行する
 *
 * @param selector 指定した要素
 * @param attr 指定した属性
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param updateGlobalVariable グローバル変数を更新する関数
 */
export const updateGlobalVariableByAttr: UpdateGlobalVariableByAttr = (
  selector,
  attr,
  globalObj,
  propertyName,
  updateGlobalVariable
) => {
  updateGlobalVariable(
    globalObj,
    propertyName,
    parseInt(
      $(selector)
        .attr(attr)
        .replace(/[^0-9]/g, '')
    )
  );
};

/**
 * 変更前の値をグローバル変数に代入する
 *
 * @param existsElement 要素の存在確認を行う関数
 * @param isEmptyText 指定した要素の文字が空文字かどうか確認する関数
 * @param updateGlobalVariable グローバル変数を更新する関数
 * @param existsChildElement 指定した要素の子要素の存在確認を行う関数
 * @param isChildElementForJustOne 指定した要素の子要素が１つだけ存在するかどうかの確認を行う関数
 * @param updateGlobalVariableByChildElement 子要素の値の数値部分を抽出してグローバル変数を更新する関数を実行する関数
 * @param selector 指定した要素
 * @param childSelector 子要素
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param getElement wc要素を取得する関数
 * @param updateGlobalVariableForWc wcの要素の属性の値からグローバルの値を更新する
 * @param wcSelector wc要素のセレクター
 * @param attr 属性名
 */
export const updateGlobalVariableBeforeChange: UpdateGlobalVariableBeforeChange = (
  existsElement,
  isEmptyText,
  updateGlobalVariable,
  existsChildElement,
  isChildElementForJustOne,
  updateGlobalVariableByChildElement,
  selector,
  childSelector,
  globalObj,
  propertyName,
  getElement,
  updateGlobalVariableForWc,
  wcSelector,
  attr
) => () => {
  const element = getElement(wcSelector);
  if (element) {
    updateGlobalVariableForWc(
      updateGlobalVariable,
      element,
      attr,
      globalObj,
      propertyName,
      -1
    );
  }
  if (!existsElement(selector)) return;
  if (isEmptyText(selector)) {
    updateGlobalVariable(globalObj, propertyName, -1);
  } else if (existsChildElement(selector, childSelector)) {
    if (isChildElementForJustOne(selector, childSelector)) {
      updateGlobalVariableByChildElement(
        selector,
        childSelector,
        globalObj,
        propertyName,
        updateGlobalVariable
      );
    } else {
      updateGlobalVariableByChildElement(
        `${selector}:eq(0)`,
        childSelector,
        globalObj,
        propertyName,
        updateGlobalVariable
      );
    }
  } else {
    updateGlobalVariable(globalObj, propertyName, 0);
  }
};

/**
 * 変更後の値をグローバル変数に代入する
 *
 * @param existsElement 要素の存在確認を行う関数
 * @param updateGlobalVariable グローバル変数を更新する関数
 * @param existsChildElement 指定した要素の子要素の存在確認を行う関数
 * @param updateGlobalVariableByChildElement 子要素の値の数値部分を抽出してグローバル変数を更新する関数を実行する関数
 * @param selector 指定した要素
 * @param childSelector 子要素
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param getElement wc要素を取得する関数
 * @param updateGlobalVariableForWc wcの要素の属性の値からグローバルの値を更新する
 * @param wcSelector wc要素のセレクター
 * @param attr 属性名
 */
export const updateGlobalVariableAfterChange: UpdateGlobalVariableAfterChange = (
  existsElement,
  updateGlobalVariable,
  existsChildElement,
  updateGlobalVariableByChildElement,
  selector,
  childSelector,
  globalObj,
  propertyName,
  getElement,
  updateGlobalVariableForWc,
  wcSelector,
  attr
) => () => {
  const element = getElement(wcSelector);
  if (element) {
    updateGlobalVariableForWc(
      updateGlobalVariable,
      element,
      attr,
      globalObj,
      propertyName,
      0
    );
  }
  if (!existsElement(selector)) return;
  if (existsChildElement(selector, childSelector)) {
    updateGlobalVariableByChildElement(
      `${selector}:eq(0)`,
      childSelector,
      globalObj,
      propertyName,
      updateGlobalVariable
    );
  } else {
    updateGlobalVariable(globalObj, propertyName, 0);
  }
};

/**
 * 補足用の要素の属性の値をグローバル変数に代入する
 *
 * @param existsElement 要素の存在確認を行う関数
 * @param updateGlobalVariable グローバル変数を更新する関数
 * @param updateGlobalVariableByAttr 指定した要素の属性の値の数値部分を抽出してグローバル変数を更新する関数を実行する関数
 * @param selectorForExists 存在確認用の要素
 * @param selectorForAssign 変数代入用の要素
 * @param attr 指定した属性
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param getElement wc要素を取得する関数
 * @param updateGlobalVariableForWc wcの要素の属性の値からグローバルの値を更新する
 * @param wcSelector wc要素のセレクター
 * @param wcAttr 属性名
 */
export const updateGlobalVariableForSup: UpdateGlobalVariableForSup = (
  existsElement,
  updateGlobalVariable,
  updateGlobalVariableByAttr,
  selectorForExists,
  selectorForAssign,
  attr,
  globalObj,
  propertyName,
  getElement,
  updateGlobalVariableForWc,
  wcSelector,
  wcAttr
) => () => {
  if (existsElement(selectorForExists)) {
    updateGlobalVariableByAttr(
      selectorForAssign,
      attr,
      globalObj,
      propertyName,
      updateGlobalVariable
    );
  } else {
    updateGlobalVariable(globalObj, propertyName, 0);
  }
  const element = getElement(wcSelector);
  if (element) {
    updateGlobalVariableForWc(
      updateGlobalVariable,
      element,
      wcAttr,
      globalObj,
      propertyName,
      0
    );
  }
};

/**
 * wcに属性を付与するコンテンツがない場合は該当する属性を削除
 *
 * @param setAttr 属性を設定する関数
 * @param setCurrentAttr 現在の手数料の属性値を設定する関数
 * @param setRestAttr 残りの値段の属性値をを設定する関数
 * @param setDiscountedAttr 次の手数料の属性値を設定する関数
 * @param removeAttr 属性を削除する関数
 * @param element 属性を設定するエレメント
 * @param currentAttr 現在の手数料の属性名
 * @param restAttr 残りの値段の属性名
 * @param discountedAttr 次の手数料の属性名
 * @param currentSelector 現在の手数料用のセレクター
 * @param restSelector 残りの値段用のセレクター
 * @param restAttrName 残りの値段用の属性名
 * @param discountedSelector 次の手数料用のセレクター
 * @param subject 手数料名
 * @param content コンテント
 */
export const updateWcContent: UpdateWcContent = (
  setAttr,
  setCurrentAttr,
  setRestAttr,
  setDiscountedAttr,
  removeAttr,
  element,
  currentAttr,
  restAttr,
  discountedAttr,
  currentSelector,
  restSelector,
  restAttrName,
  discountedSelector,
  subject,
  content
) => {
  if (content) {
    setCurrentAttr(setAttr, element, currentAttr, currentSelector, content);
    setRestAttr(
      setAttr,
      element,
      restAttr,
      restSelector,
      restAttrName,
      content
    );
    setDiscountedAttr(
      setAttr,
      element,
      discountedAttr,
      discountedSelector,
      subject,
      content
    );
  } else {
    removeAttr(element, currentAttr);
    removeAttr(element, restAttr);
    removeAttr(element, discountedAttr);
  }
};

/**
 * 現在の手数料の属性値を設定する
 *
 * @param setAttr 属性を設定する関数
 * @param element 属性を設定するエレメント
 * @param attr 設定する属性名
 * @param selector 指定した要素
 * @param content コンテント
 */
export const setCurrentAttr: SetCurrentAttr = (
  setAttr,
  element,
  attr,
  selector,
  content
) => {
  const container = document.createElement('div');
  container.innerHTML = content;
  const current = container.querySelector(selector);
  if (current) {
    setAttr(element, attr, current.innerHTML.replace(/[^0-9]/g, ''));
  } else {
    setAttr(element, attr, '0');
  }
};

/**
 * 残りの値段の属性値を設定する
 *
 * @param setAttr 属性を設定する関数
 * @param element 属性を設定するエレメント
 * @param attr 設定する属性名
 * @param selector 指定した要素
 * @param attrName コンテントから取得する属性名
 * @param content コンテント
 */
export const setRestAttr: SetRestAttr = (
  setAttr,
  element,
  attr,
  selector,
  attrName,
  content
) => {
  const container = document.createElement('div');
  container.innerHTML = content;
  const current = container.querySelector(selector);
  if (current) {
    const attrValue = current.getAttribute(attrName);
    if (attrValue) setAttr(element, attr, attrValue.replace(/[^0-9]/g, ''));
  } else {
    setAttr(element, attr, '0');
  }
};

/**
 * 次の手数料の属性値を設定する
 *
 * @param setAttr 属性を設定する関数
 * @param element 属性を設定するエレメント
 * @param attr 設定する属性名
 * @param selector 指定した要素
 * @param subject 手数料名
 * @param content コンテント
 */
export const setDiscountedAttr: SetDiscountedAttr = (
  setAttr,
  element,
  attr,
  selector,
  subject,
  content
) => {
  const container = document.createElement('div');
  container.innerHTML = content;
  const current = container.querySelector(selector);
  if (current) {
    setAttr(element, attr, '0');
  } else {
    const texts = container.innerHTML.split(subject);
    if (texts[1]) {
      setAttr(element, attr, texts[1].replace(/[^0-9]/g, ''));
    }
  }
};
/**
 * wcの要素の属性の値からグローバルの値を更新する
 *
 * @param updateGlobalVariable グローバル変数を更新する関数
 * @param element wcの要素
 * @param attr 属性
 * @param globalObj 任意のオブジェクト
 * @param propertyName 代入するプロパティ名
 * @param value 属性が存在しないときに入れる値
 */
export const updateGlobalVariableForWc: UpdateGlobalVariableForWc = (
  updateGlobalVariable,
  element,
  attr,
  globalObj,
  propertyName,
  value
) => {
  const attrValue = element.getAttribute(attr);
  if (attrValue) {
    updateGlobalVariable(globalObj, propertyName, parseInt(attrValue));
  } else {
    updateGlobalVariable(globalObj, propertyName, value);
  }
};
